export default __webpack_public_path__ + "static/media/se.56b78fc6.svg";